export default "__VITE_ASSET__CtqH2hzx__"